// 🔧 demo_context.js
// ✅ Purpose: Shared execution context for the LGV Demo Engine
// ✅ Features:
// - Provides a single shared object for all builders
// - Eliminates passing dozens of individual result objects
// - Becomes the source of truth for the current demo build
// - Future-ready for all Phase 2 add-on builders
// - Fully block-commented for clarity and future devs

export const createDemoContext = ({
  user,
  demoConfig,
  seedProfile,
  industryTemplate,
  eventResult = null,
} = {}) => {
  return {
    user,

    demoConfig,

    seedProfile,

    industryTemplate,

    // Existing demo events can enter the pipeline after the Event Builder.
    // This is used when an administrator enables another Power Up later.
    eventResult,

    // Match the convenience values normally installed by Event Builder's
    // afterSuccess hook so later Power Up engines receive the same contract.
    event: eventResult,
    eventName: eventResult?.eventName || eventResult?.name || "",
    eventSlug: eventResult?.slug || eventResult?.eventSlug || "",

    categoryResult: null,

    entryResult: null,

    userResult: null,

    voteResult: null,

    sponsorResult: null,

    volunteerResult: null,

    vendorResult: null,

    ticketResult: null,

    auctionResult: null,

    passportResult: null,
    scheduleResult: null,

    scheduleItems: [],
    mapResult: null,
    contentResult: null,

  };
};
